import { getFlagsConsoleApi, initFlags } from '@rsos/feature-flags';
import { toDatadogEnv } from '@rsos/feature-flags/helpers';
import exportToGlobalNamespace from './exportToGlobalNamespace';
import {
  getDatadogApplicationId,
  getDatadogClientToken,
  getMCOEnvironment,
  getProxyOrigin,
} from './metaTags';
import { captureExceptionWithScope } from './sentry';

/**
 * Wires up `@rsos/feature-flags` for portal_renderer apps.
 *
 * The package itself takes no config from its surroundings, so this is the one place
 * that knows flags are delivered to this host via meta tags, that errors go to
 * Sentry, and that the console API hangs off `window.__RSOS`. Call it once at an app
 * root, before mounting `<OpenFeatureProvider>`.
 */
export const initPortalFlags = (): void => {
  initFlags({
    clientToken: getDatadogClientToken(),
    applicationId: getDatadogApplicationId(),
    env: toDatadogEnv(getMCOEnvironment()),
    proxyOrigin: getProxyOrigin(),
    onError: captureExceptionWithScope,
  });
  exportToGlobalNamespace('flags', getFlagsConsoleApi());
};
